var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap tax_invoice_request_pop",
      staticStyle: { width: "600px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(_vm._s(_vm.$t("msg.ADD20260813.001"))),
        ]),
        _c("div", { staticClass: "content_box" }, [
          _c("table", { staticClass: "tbl_row" }, [
            _vm._m(0),
            _c("tbody", [
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.009")))]),
                _c("td", [
                  _c("span", { staticClass: "font_medium" }, [
                    _vm._v(
                      _vm._s(_vm.blNoList.length) +
                        " " +
                        _vm._s(_vm.$t("msg.ADD20260813.010"))
                    ),
                  ]),
                  _vm.blNoList.length > 0
                    ? _c("p", { staticClass: "txt_desc none" }, [
                        _vm._v(_vm._s(_vm.blNoList.join(", "))),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.011")))]),
                _c("td", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.params.cstName,
                        expression: "params.cstName",
                        modifiers: { trim: true },
                      },
                    ],
                    attrs: {
                      type: "text",
                      id: "taxInvReqCompNm",
                      maxlength: "100",
                    },
                    domProps: { value: _vm.params.cstName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.params,
                          "cstName",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
              ]),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.012")))]),
                _c("td", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.params.emlAddr,
                        expression: "params.emlAddr",
                        modifiers: { trim: true },
                      },
                    ],
                    attrs: {
                      type: "text",
                      id: "taxInvReqEmlAddr",
                      maxlength: "100",
                    },
                    domProps: { value: _vm.params.emlAddr },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.params,
                          "emlAddr",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
              ]),
              _c("tr", [
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.013")))]),
                _c("td", [
                  _c("p", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.params.invMethod,
                          expression: "params.invMethod",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "taxInvReqCurCny",
                        name: "taxInvReqCur",
                        value: "01",
                      },
                      domProps: { checked: _vm._q(_vm.params.invMethod, "01") },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.params, "invMethod", "01")
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "taxInvReqCurCny" } }, [
                      _c("span"),
                      _vm._v(_vm._s(_vm.$t("msg.ADD20260813.014"))),
                    ]),
                  ]),
                  _c("p", { staticClass: "txt_desc none" }, [
                    _vm._v(_vm._s(_vm.$t("msg.ADD20260813.015"))),
                  ]),
                  _c("p", { staticClass: "mt5" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.params.invMethod,
                          expression: "params.invMethod",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "taxInvReqCurSep",
                        name: "taxInvReqCur",
                        value: "02",
                      },
                      domProps: { checked: _vm._q(_vm.params.invMethod, "02") },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.params, "invMethod", "02")
                        },
                      },
                    }),
                    _c("label", { attrs: { for: "taxInvReqCurSep" } }, [
                      _c("span"),
                      _vm._v(_vm._s(_vm.$t("msg.ADD20260813.016"))),
                    ]),
                  ]),
                  _c("p", { staticClass: "txt_desc none" }, [
                    _vm._v(_vm._s(_vm.$t("msg.ADD20260813.017"))),
                  ]),
                ]),
              ]),
              _vm.params.invMethod === "01"
                ? _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.018")))]),
                    _c("td", [
                      _c("span", { staticClass: "color_red font_medium" }, [
                        _vm._v(_vm._s(_vm.exRateText)),
                      ]),
                      _c("p", { staticClass: "txt_desc none" }, [
                        _vm._v(_vm._s(_vm.$t("msg.ADD20260813.019"))),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "mt10 text_center" }, [
          _c(
            "a",
            {
              staticClass: "button blue lg",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.020")))]
          ),
          _c(
            "a",
            {
              staticClass: "button gray lg",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("msg.ADD20260813.021")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "160px" } }),
      _c("col", { attrs: { width: "*" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }